import { render } from "./WhyUs.vue?vue&type=template&id=10943a56&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"

import "./WhyUs.vue?vue&type=style&index=0&id=10943a56&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10943a56"]])

export default __exports__